import { useMediaQuery, useTheme } from '@mui/material';
export var useViewport = function () {
    var breakpoints = useTheme().breakpoints;
    var isXs = useMediaQuery(breakpoints.down('sm'));
    var isSm = useMediaQuery(breakpoints.down('md'));
    var isMd = useMediaQuery(breakpoints.down('lg'));
    var isLg = useMediaQuery(breakpoints.down('xl'));
    return { isXs: isXs, isSm: isSm, isMd: isMd, isLg: isLg };
};
